module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-right-faa2e4d52c25b1bb18d3933ad142c25e.svg";